<template>
  <div>
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>
    <md-empty-state
      v-if="loadingError"
      md-icon="announcement"
      md-label="Invititation is unavailable, refresh"
      :md-description="loadingError"
    />
    <b-row v-else>
      <b-col>
        <md-empty-state
          v-if="!loading && invites.length == 0"
          md-icon="group"
          md-label="No Invitations"
          md-description="Invite managers, accountants and others to access your organization"
        >
          <moow-button :type="['light']" btnText="Invite user" @mClick="showInviteDialog = true" />
        </md-empty-state>
        <div v-else-if="!loading">
          <moow-button :type="['light']" btnText="Invite user" @mClick="showInviteDialog = true" />

          <b-row>
            <b-col
              class="mt-2"
              cols="12"
              md="6"
              v-for="(invitation, index) in invites"
              :key="invitation.id+index"
            >
              <div v-if="invitation.loading">
                <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
              </div>
              <md-list class="md-double-line invites-list" v-else>
                <md-list-item>
                  <md-icon class="md-primary">person_pin</md-icon>

                  <div class="md-list-item-text">
                    <span>{{invitation.email}}</span>
                    <span>email</span>
                  </div>

                  <md-button
                    @click="prepareForRevoke(invitation.id)"
                    class="md-icon-button md-list-action"
                    v-if="invitation.status=='pending'"
                  >
                    <md-icon style="color:red">pan_tool</md-icon>
                    <md-tooltip md-direction="bottom">Revoke invitation</md-tooltip>
                  </md-button>
                </md-list-item>
                <md-list-item class="md-inset">
                  <div class="md-list-item-text">
                    <span>{{invitation.status}}</span>
                    <span>status</span>
                  </div>
                </md-list-item>
                <md-list-item class="md-inset">
                  <div class="md-list-item-text">
                    <span>{{invitation.role}}</span>
                    <span>role</span>
                  </div>
                </md-list-item>
                <md-list-item class="md-inset">
                  <div class="md-list-item-text">
                    <span>{{formatTimeToDDMMYYGate(invitation.createdAt)}}</span>
                    <span>invited on</span>
                  </div>
                </md-list-item>
              </md-list>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <md-dialog :md-active.sync="showInviteDialog">
      <md-dialog-title>Invite new user</md-dialog-title>
      <md-tabs md-dynamic-height>
        <md-tab md-label="Invite">
          <md-field :class="{'md-invalid': emailErr}" class="moow-input">
            <label>Invite email</label>
            <md-input v-model="inviteeEmail"></md-input>
            <span class="md-error">{{emailErr}}</span>
          </md-field>
          <md-field :class="{'md-invalid': roleErr}" class="moow-input">
            <label for="role">Select Role</label>
            <md-select v-model="inviteeRole" name="role" id="role">
              <md-option value="admin">Admin</md-option>
              <md-option value="manager">Manager</md-option>
              <md-option value="accountant">Accountant</md-option>
            </md-select>
            <span class="md-error">{{roleErr}}</span>
          </md-field>
        </md-tab>
        <md-tab md-label="Roles">
          <p>
            <strong>Admin</strong> has access to everything
          </p>
          <p>
            <strong>Manager</strong> has write access to all resources but cannot edit account or invite others
          </p>
          <p>
            <strong>Accountant</strong> can view all resources but has limited edit access (e.g can add Notes but cannot delete Deals)
          </p>
        </md-tab>
      </md-tabs>

      <md-dialog-actions>
        <div v-if="invitationLoading">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </div>

        <div v-else>
          <moow-button
            :type="['dark', 'flat', 'outlined']"
            btnText="Cancel"
            @mClick="showInviteDialog=false"
          />
          <moow-button :type="['light']" btnText="Invite" @mClick="inviteUser" />
        </div>
      </md-dialog-actions>
    </md-dialog>

    <moow-dialog-confirm
      title="Revoke this invitation?"
      content="Invited user will not be able to join the organization and this invitation will be deleted"
      confirmText="Revoke"
      cancelText="Wait"
      :showDialog="showRevokeConfirmDialog"
      @mConfirm="revokeInvitation"
      @mCancel="showRevokeConfirmDialog=false"
    />

    <md-snackbar md-persistent :md-active.sync="showSnackbar">
      <span>{{snackbarMessage}}</span>
    </md-snackbar>
  </div>
</template>
<script>
import InfoToggle from "@/components/interface/buttons/infoToggle.vue";
import { mapGetters } from "vuex";
import { formatTimeToMonthDDYY } from "@/timeFunctions.js";

export default {
  components: {
    InfoToggle,
  },
  data() {
    return {
      revokeInviteId: undefined,
      showSnackbar: false,
      snackbarMessage: "",
      showRevokeConfirmDialog: false,
      showInviteDialog: false,
      inviteeEmail: "",
      inviteeRole: "",
      expandNews: false,
      expandSingle: false,
      rules: {
        emailRule: /.+@.+/,
      },
      emailErr: "",
      roleErr: "",
    };
  },

  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),

    invites() {
      return this.$store.getters.accountInvities.invites;
    },
    selectedAccountId() {
      if (this.$store.getters.connectedAccountIds.length > 0)
        return this.$store.getters.connectedAccountIds[0];
      return null;
    },
    invitationLoading() {
      return this.$store.getters.invitationLoading;
    },
    loading() {
      return this.$store.getters.loadingAccountInvites;
    },
    loadingError() {
      return this.$store.getters.loadingAccountInvitesErr;
    },
    accountName() {
      return this.$store.getters.accountName;
    },
    currentUserUid() {
      if (this.$store.getters.user) return this.$store.getters.user.uid;
      else return false;
    },
    currentUserEmail() {
      if (this.$store.getters.user) return this.$store.getters.user.email;
      else return false;
    },
  },
  watch: {
    inviteeEmail: function (val, oldVal) {
      if (val && val != oldVal) {
        if (this.rules.emailRule.test(val)) this.emailErr = "";
        else this.emailErr = "Invalid email";
      } else this.emailErr = "Required";
    },
    inviteeRole: function (val, oldVal) {
      if (val) this.roleErr = "";
      else this.roleErr = "Required";
    },
    selectedAccountId: function (val, oldVal) {
      if (val && !this.loading)
        this.getAccountInvites({ accountId: val, refresh: true });
    },
  },
  created() {
    if (this.selectedAccountId)
      this.getAccountInvites({
        accountId: this.selectedAccountId,
        refresh: true,
      });
  },
  updated() {},
  methods: {
    refreshInvites() {
      if (this.selectedAccountId)
        this.getAccountInvites({
          accountId: this.selectedAccountId,
          refresh: true,
        });
    },
    prepareForRevoke(inviteId) {
      this.revokeInviteId = inviteId;
      this.showRevokeConfirmDialog = true;
    },
    revokeInvitation() {
      this.revokeInviteId
        ? this.$store.dispatch("revokeInvitation", {
            inviteId: this.revokeInviteId,
            accountId: this.selectedAccountId,
          })
        : void 0;
    },
    getAccountInvites(accountId) {
      this.$store.dispatch("getAccountInvites", accountId);
    },
    inviteUser() {
      if (!this.validateInvitationForm()) return;
      this.$store.dispatch("inviteAccountUser", {
        accountId: this.selectedAccountId,
        inviterUid: this.currentUserUid,
        invitorName: this.accountName,
        inviteeEmail: this.inviteeEmail.trim(),
        role: this.inviteeRole,
      });
      this.clearInvitationForm();
      this.showInviteDialog = false;
    },
    clearInvitationForm() {
      this.inviteeRole = "";
      this.inviteeEmail = "";
    },
    validateInvitationForm() {
      if (!this.rules.emailRule.test(this.inviteeEmail)) {
        this.emailErr = "Required";
        return false;
      }
      if (!this.inviteeRole) {
        this.roleErr = "Required";
        return false;
      }

      if (this.inviteeEmail == this.currentUserEmail) {
        this.showSnackbar = true;
        this.snackbarMessage = "You cannot invite yourself";
        return false;
      }
      return true;
    },
    formatTimeToDDMMYYGate(date) {
      return formatTimeToMonthDDYY(date);
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";

.invites-list {
  border-radius: 4px;
  border: 1px solid #414042;
}
</style>



// WEBPACK FOOTER //
// src/components/account/UserInvites.vue